import {Component, Inject, OnDestroy, signal} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

import {ReplaySubject} from 'rxjs';
import {skip, distinctUntilChanged} from 'rxjs/operators';

import {MatSnackBarRef, MAT_SNACK_BAR_DATA} from '@angular/material/snack-bar';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {TranslateModule} from '@ngx-translate/core';

import * as PL2 from '@common/utils/dist/models/models-pl2.js';
import {KeyUtilsPL2 as KU} from '@common/utils/dist/utils/key-utils-pl2.js';

import {EntryStore} from '@stores/entry.store';
import {RouteStore} from '@stores/route.store';

@Component({
  standalone: true,
  selector: 'undo-create-snackbar',
  templateUrl: 'undo-create-snackbar.component.html',
  styleUrls: ['undo-create-snackbar.component.scss'],
  imports: [MatButtonModule, MatIconModule, TranslateModule],
})
export class UndoCreateSnackBarComponent implements OnDestroy {
  message = signal('');
  undone = signal(false);

  private destroyed$ = new ReplaySubject<boolean>();

  constructor(
    private snackBarRef: MatSnackBarRef<UndoCreateSnackBarComponent>,
    private entryStore: EntryStore,
    private routeStore: RouteStore,
    @Inject(MAT_SNACK_BAR_DATA)
    private data: {entry: PL2.AnyEntry; message: string},
  ) {
    this.message.set(this.data.message);
    this.routeStore.state$
      .pipe(
        distinctUntilChanged(
          (prev, curr) =>
            prev.pageName === curr.pageName &&
            prev.containerId === curr.containerId,
        ),
        skip(1),
        takeUntilDestroyed(),
      )
      .subscribe(() => {
        this.snackBarRef.dismiss();
      });
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  undoCreate() {
    this.entryStore.delete({id: KU.keyFromEntry(this.data.entry)});
    this.snackBarRef.dismissWithAction();
  }

  close() {
    this.snackBarRef.dismiss();
  }
}
